module.exports = __webpack_public_path__ + "img/danhuangjungu.36676148.jpg";